module.exports = __webpack_public_path__ + "static/media/AL.03b2d550.jpg";